export enum LoginErrorEnum {
    NotValid = 1,
    PasswordNotValid = 2,
    PasswordExpired = 3,
    BlockedUser = 4,
    NamePasswordEmpty = 5,
    UserNotValid = 6
}


// WEBPACK FOOTER //
// ./src/app/_enums/login-error.enum.ts